<template>
  <div class="chartOne">
    <!-- <h4>{{ chartTitle }}</h4> -->
    <div :id="codMain" class="codMain"></div>
  </div>
</template>

<script>

let myChart;

export default {
  name: "MiniChart",
  props: {
    codMain: String,
    ChartData: Object,
  },
  data() {
    return {
      // timer: null,
      myChart: null,
      chartData: {},
      seriesData: [],
      openIndex: null,
      chartTitle: "",
      initOption: {
        backgroundColor: '',

        animation: true,
        animationDuration: 1500,
        dataZoom: [
          {
            type: "inside",
          },
        ],
        grid: {
          top: "10%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",

        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          }
        },
        tooltip: {
          confine: true,
          trigger: "axis", // 当鼠标移动到坐标轴时触发
          axisPointer: {
            type: "line",
            z: 0,
            lineStyle: {
              color: "#2D3443",
            },
          },
          textStyle: {
            align: "left",
          },
          extraCssText: "z-index: 99999",
        },
        series: [
          {
            name: "",
            data: "",
            symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            type: "line",
            // areaStyle: {
            //   color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //     { offset: 0, color: "#FE7D2F" },
            //     { offset: 1, color: "#F9D423" },
            //   ]),
            // },

            label: {
              show: false, // 是否显示文字
              position: "right", // 文字位置
            },
            // lineStyle: { width: 1.6, type: 'dashed' },
            itemStyle: {
              normal: {
                color: '#498AF4', //改变折线点的颜色
                lineStyle: {
                  color: '#498AF4',//改变折线颜色

                }
              }
            },
            zlevel: 999,
          },
        ],
      },
    };
  },
  beforeUnmount() {
    myChart.clear();
    // clearInterval(this.timer);
  },
  mounted() {
    console.log(this.ChartData);
    this.initChart();

    console.log(this.initChart);
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  },
  computed: {
    // ...mapState(useCommonStore, ["theme", "open"]),
  },
  watch: {
    open() {
      console.log("edfgbhdfg123");
      myChart.resize();
    },
    theme() {
      myChart.clear();
      this.initChart();
    },
    ChartData() {

      myChart.clear();
      this.initChart();
    },
  },
  methods: {
    initChart() {
      console.log(this.ChartData);
      this.chartTitle = this.ChartData.title;
      this.chartUnit = this.ChartData.legend.unit;
      if (this.chartUnit == '-') {
        this.chartUnit = ''
      }
      this.initOption.xAxis.data = this.ChartData.xAxis;
      this.initOption.title = {
        left: "center",
        text: this.chartTitle,
        show: false,
      };
      this.initOption.yAxis = [
        {
          type: "value",
          splitLine: {
            show: false
          }
        },
      ];
      this.initOption.series = {
        name: this.ChartData.legend.name,
        data: this.ChartData.legend.yAxis,
        symbol: "none", //去掉折线图中的节点
        // smooth: true, //true 为平滑曲线，false为直线
        type: "line",
        // yAxisIndex: index,
        areaStyle: {
          normal: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
              [{
                offset: 0,
                color: "rgba(67, 142, 217, 0.8)",
              }, {
                offset: 1, color: 'rgba(67, 142, 217, 0.1)'
              }]),
            // #5E78C9
            // #91CC75
          },
        },
        label: {
          show: false, // 是否显示文字
          position: "right", // 文字位置
        },
        lineStyle: { width: 1.6, },
        itemStyle: {
          normal: {
            color: '#498AF4', //改变折线点的颜色
            lineStyle: {
              color: '#2466A8',//改变折线颜色

            }
          }
        },


      };

      console.log(this.initOption);

      let newPromise = new Promise((resolve) => {
        resolve();
      });
      newPromise.then(() => {
        let that = this;
        myChart = this.$echarts.init(
          document.getElementById(this.codMain),
          this.theme
        ); // 使用dark 、light或无第二参数
        myChart.setOption(this.initOption);
        // console.log(myChart);
        myChart.getZr().on("click", function (param) {
          if (param.offsetY > 60) {
            that.$emit("closedrawer");
            console.log(23232434343);
            console.log(param);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chartOne {
  width: 100%;
  // height: 100%;
  margin: 0 auto;
  // margin-right: 100px;

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    //滑块部分
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .codMain {
    width: 100%;
    height: 220px;
    margin: 0 auto;
  }

  h4 {
    padding-top: 10px;
    padding-left: 36px;
    font-size: 16px;
    color: rgb(76, 76, 76);
  }
}
</style>
